import Model from './model.js';

export default class AnnotationAuditLog extends Model {
  static get callbackIdentifier() {
    return 'annotation-audit-log';
  }

  _initProperties() {
    super._initProperties();

    this.actorUser = null;
    this.actorUsername = null;
    this.project = null;
    this.image = null;
    this.slice = null;
    this.annotationIdent = null;
    this.annotationType = null;
    this.action = null;
    this.command = null;
    this.details = null;
  }
}
